import { instanceOf } from 'prop-types';

export default instanceOf(Error);
